import { useMutation } from "react-query";
import { useRouter } from "../../useRouter";
import { logout } from "src/service/sessions";
import { notifySuccess } from "src/components/Common/Toast";
import { useApiError } from "../../useApiError";
import { useQueryClient } from "react-query";
import { removeUserInfoFromLocalStorage } from "src/utils/storage/auth";
import { productKeyAtom, userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { IUserInfo } from "src/service/types/common.type";

// 로그인 유효한지 확인하는 Hook
export function useLogout() {
  const router = useRouter();
  const { handleError } = useApiError();
  const abortController = new AbortController();
  const queryClient = useQueryClient();
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { mutateAsync: mutateLogout } = useMutation("logout", logout, {
    onSuccess: async () => {
      removeUserInfoFromLocalStorage();

      // 쿼리와 뮤테이션 캐시 모두 클리어
      queryClient.clear();
      queryClient.getMutationCache().clear();

      abortController.abort();

      // 스토리지 정리
      const userId = localStorage.getItem("potal.wrapsodyeco.com_userId");
      if (userId) {
        localStorage.clear();
        localStorage.setItem("potal.wrapsodyeco.com_userId", userId);
      }
      sessionStorage.clear();

      setProductKey(undefined);
      setUserInfo({} as IUserInfo);
      router.goLogin();
    },

    onError: handleError,
  });

  return { mutateLogout };
}
